import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=36ae5631&scoped=true&"
import script from "./EventCard.vue?vue&type=script&lang=js&"
export * from "./EventCard.vue?vue&type=script&lang=js&"
import style0 from "./EventCard.vue?vue&type=style&index=0&id=36ae5631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae5631",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ae5631')) {
      api.createRecord('36ae5631', component.options)
    } else {
      api.reload('36ae5631', component.options)
    }
    module.hot.accept("./EventCard.vue?vue&type=template&id=36ae5631&scoped=true&", function () {
      api.rerender('36ae5631', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/event/EventCard.vue"
export default component.exports